export const getLetterTemplateList = state => {
    return state.list
}

export const getLetterTemplateDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/letterTemplate/getters.js